module.exports = __webpack_public_path__ + "img/BitSprint.7d4084ae.gif";